import { DMT_ADDR, RPC_POLLING_INTERVAL } from '@src/lib/consts';
import { useAccount, useBalance } from 'wagmi';

export default function useDMTBalance({ watch }: { watch?: boolean } = {}) {
  const { address } = useAccount();

  return useBalance({
    address,
    token: DMT_ADDR,
    query: {
      enabled: !!address,
      refetchInterval: watch ? RPC_POLLING_INTERVAL : false,
    },
  });
}
